import styled from "styled-components";
import { Modal } from "@ann/web-components";

export const AddGroupModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ModalBodyNoPadding = styled(Modal.Body)`
  padding: 0;
`;

export const GroupsSearchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const GroupsSearchInputWrapper = styled.div`
  flex: 1;
  max-width: 420px;
`;

export const GroupsSearchSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  color: ${(props) => props.theme.colors.greyFour};
  white-space: nowrap;
`;

export const GroupsSelectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  max-height: 380px;
  overflow-y: auto;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  width: 100%;
`;

export const SelectedGroupsSummary = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: ${(props) => props.theme.spacing?.radiusM || "12px"};
  padding: ${(props) => props.theme.spacing?.spacing2x || "16px"};
  background: ${(props) => props.theme.colors?.titanWhite || "#E9F1FF"};
  margin-top: 16px;
`;

export const SelectedGroupsInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
`;

export const SelectedGroupsTitle = styled.div`
  font-family: ${(props) => props.theme.typography?.subtitle?.bold?.family || "Inter"};
  font-weight: ${(props) => props.theme.typography?.subtitle?.bold?.weight || 600};
  font-size: ${(props) => props.theme.typography?.subtitle?.bold?.size || "16px"};
  line-height: 100%;
`;

export const SelectedGroupsText = styled.div`
  font-family: ${(props) => props.theme.typography?.body?.medium?.family || "Inter"};
  font-weight: ${(props) => props.theme.typography?.body?.medium?.weight || 400};
  font-size: ${(props) => props.theme.typography?.body?.medium?.size || "14px"};
  line-height: 100%;
  color: ${(props) => props.theme.colors?.greyFour || "#6B7280"};
`;

export const ClearGroupsSelectionText = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: ${(props) => props.theme.colors?.primary || props.theme.colors?.blue || "#1D4ED8"};
  font-family: ${(props) => props.theme.typography?.link?.regular?.family || "Inter"};
  font-weight: ${(props) => props.theme.typography?.link?.regular?.weight || 400};
  font-size: ${(props) => props.theme.typography?.link?.regular?.size || "14px"};
  line-height: 100%;
  letter-spacing: 0;
  font-style: normal;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: currentColor;
  text-decoration-line: underline;
  text-decoration-thickness: 0%;
  text-decoration-offset: 0%;
`;

